export function GuideMascot({ className = 'h-16 w-16' }: { className?: string }) {
  return (
    <svg viewBox="0 0 72 72" className={`${className} shrink-0`} data-testid="guide-mascot" role="img" aria-label="Guide">
      <rect width="72" height="72" rx="20" fill="#f5f0e6" />
      <path d="M16 40c2-14 10-22 20-22s18 8 20 22" fill="#0f766e" />
      <circle cx="28" cy="34" r="3" fill="#fff" />
      <circle cx="44" cy="34" r="3" fill="#fff" />
      <circle cx="28" cy="34" r="1.4" fill="#1f2937" />
      <circle cx="44" cy="34" r="1.4" fill="#1f2937" />
      <path d="M32 42h8l-2 4h-4z" fill="#d97706" />
      <path d="M18 28c4-10 10-14 18-14" fill="none" stroke="#d97706" strokeWidth="3" strokeLinecap="round" />
      <path d="M54 28c-4-10-10-14-18-14" fill="none" stroke="#d97706" strokeWidth="3" strokeLinecap="round" />
      <path d="M22 50c6 6 22 6 28 0" fill="none" stroke="#1f2937" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function WelcomeLogo() {
  return (
    <div className="flex flex-col items-center" data-testid="welcome-logo">
      <p className="text-2xl font-semibold tracking-tight text-gray-900">My New Start</p>
    </div>
  );
}

export function SignalBars({ level, filled }: { level: number; filled: boolean }) {
  return (
    <svg viewBox="0 0 56 32" className="h-8 w-14 shrink-0" aria-hidden="true" data-testid="signal-bars" data-level={level}>
      {[1, 2, 3, 4, 5].map((bar) => (
        <rect
          key={bar}
          x={4 + (bar - 1) * 10}
          y={30 - bar * 5}
          width="7"
          height={bar * 5}
          rx="1.5"
          fill={bar <= level ? (filled ? '#0f766e' : '#115e59') : '#e5e7eb'}
        />
      ))}
    </svg>
  );
}

export function GuideBubble({
  my,
  en,
  language,
}: {
  my: string;
  en: string;
  language: 'my' | 'en';
}) {
  const main = language === 'en' ? en : my;
  const sub = language === 'en' ? my : en;
  return (
    <div className="mb-5 flex items-end gap-3" data-testid="guide-bubble" data-language={language}>
      <GuideMascot />
      <div className="min-w-0 rounded-2xl rounded-bl-md bg-white px-4 py-3 shadow-sm">
        <p className="break-words text-base font-semibold leading-snug text-gray-900" data-testid="guide-main">{main}</p>
        {sub && sub !== main ? <p className="lesson-subtext mt-1 break-words text-sm leading-snug text-gray-600">{sub}</p> : null}
      </div>
    </div>
  );
}

export function ProviderIcon({ provider }: { provider: 'apple' | 'google' | 'email' | 'facebook' }) {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0" data-testid="settings-provider" data-provider={provider} aria-hidden="true">
      {provider === 'apple' ? (
        <path fill="#111827" d="M16.4 12.6c0-2.2 1.8-3.2 1.9-3.3-1-1.5-2.6-1.7-3.2-1.7-1.3-.1-2.6.8-3.3.8s-1.7-.8-2.8-.7c-1.5.1-2.8.9-3.5 2.2-1.5 2.6-.4 6.5 1.1 8.6.7 1 1.6 2.2 2.7 2.1 1.1 0 1.5-.7 2.8-.7s1.7.7 2.8.7 1.9-1.1 2.6-2.1c.8-1.2 1.1-2.3 1.2-2.4-.1 0-2.2-.9-2.3-3.5zM14.7 6.4c.6-.7 1-1.7.9-2.7-.9 0-1.9.6-2.5 1.3-.6.6-1.1 1.7-.9 2.6 1 .1 1.9-.5 2.5-1.2z" />
      ) : null}
      {provider === 'google' ? (
        <>
          <circle cx="12" cy="12" r="8" fill="none" stroke="#0f766e" strokeWidth="2" />
          <path d="M12 8v8M8 12h8" stroke="#d97706" strokeWidth="2" strokeLinecap="round" />
        </>
      ) : null}
      {provider === 'facebook' ? (
        <>
          <rect x="4" y="4" width="16" height="16" rx="4" fill="none" stroke="#0f766e" strokeWidth="2" />
          <path d="M13 8v8M11 10h4" stroke="#0f766e" strokeWidth="2" strokeLinecap="round" />
        </>
      ) : null}
      {provider === 'email' ? (
        <>
          <rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="#0f766e" strokeWidth="2" />
          <path d="M5 8l7 5 7-5" fill="none" stroke="#0f766e" strokeWidth="2" />
        </>
      ) : null}
    </svg>
  );
}
